/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TIdentificationGetStateModel,
  IIdentificationGetStateRequest,
  IMappers,
  IIdentificationGetStateResponse,
  IIdentificationGetStateResponseError,
  TIdentificationGetStateResponse,
} from './types';

const defaultConfig: TIdentificationGetStateModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'moderation-homeowner-free-offers',
  pathApi: '/v1/identification/get-state/',
  hostType: 'api',
} as TIdentificationGetStateModel;

function createIdentificationGetStateModel(parameters: IIdentificationGetStateRequest): TIdentificationGetStateModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IIdentificationGetStateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IIdentificationGetStateRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchIdentificationGetState<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IIdentificationGetStateOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TIdentificationGetStateResponse
> {
  const { response, statusCode } = await httpApi.fetch(createIdentificationGetStateModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IIdentificationGetStateResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IIdentificationGetStateResponseError);
    }
  }

  return { response, statusCode } as TIdentificationGetStateResponse;
}

export { defaultConfig, createIdentificationGetStateModel, fetchIdentificationGetState };
